import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box'
import Drawer, { drawerClasses } from '@mui/material/Drawer'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded'
import MenuContent from './MenuContent'
import { useAccessToken } from '@services/token/token.hooks'
import { useAtomValue } from 'jotai'
import { userAtom } from '@services/token/token.models'
import { useMemo, useState, useEffect } from 'react'
import Calendar from '@components/Calendar'
import SelectContent from './SelectContent'

interface SideMenuMobileProps {
  open: boolean | undefined
  toggleDrawer: (newOpen: boolean) => () => void
}

export default function SideMenuMobile({ open, toggleDrawer }: SideMenuMobileProps) {
  const { clearUserData } = useAccessToken()
  const user = useAtomValue(userAtom)

  // Sprawdź czy to logowanie przez Microsoft OAuth
  const [userData, setUserData] = useState<any>(null)

  useEffect(() => {
    const msUserData = localStorage.getItem('user_data')
    if (msUserData && msUserData !== 'undefined' && msUserData !== '{}') {
      try {
        const parsed = JSON.parse(msUserData)
        if (Object.keys(parsed).length > 0) {
          setUserData(parsed)
        } else {
          setUserData(null)
        }
      } catch {
        setUserData(null)
      }
    } else {
      setUserData(null)
    }
  }, [user])

  // Użyj danych z localStorage lub atomu
  const displayEmail = user || ''
  const displayName = userData?.name || userData?.first_name || userData?.given_name || ''

  const userName = useMemo(() => {
    // Jeśli mamy displayName z Microsoft, użyj go
    if (displayName && typeof displayName === 'string') {
      return displayName.split(' ')[0]
    }
    // W przeciwnym razie użyj emaila
    if (!displayEmail || typeof displayEmail !== 'string') return 'User'

    // Bezpiecznie podziel email
    const atIndex = displayEmail.indexOf('@')
    if (atIndex === -1) return displayEmail // Jeśli to nie email, zwróć jak jest

    const [localPart] = displayEmail.split('@')
    const [name] = localPart.split('.')
    return name.charAt(0).toUpperCase() + name.slice(1)
  }, [displayEmail, displayName])

  return (
    <Drawer
      anchor='right'
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: 'background.paper'
        }
      }}
    >
      <Stack
        sx={{
          maxWidth: '90vw',
          minWidth: '40vw',
          height: '100%'
        }}
      >
        <Stack direction='row' sx={{ p: 2, pb: 0, gap: 1 }}>
          <Stack direction='row' sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}>
            <Avatar
              sizes='small'
              alt={userName.toUpperCase()}
              src='/static/images/avatar/7.jpg'
              sx={{ width: 24, height: 24 }}
            />
            <Typography component='p' variant='h6'>
              {userName}
            </Typography>
          </Stack>
        </Stack>
        <Divider />
        <Box
          sx={{
            p: 1.5
          }}
        >
          <SelectContent />
        </Box>
        <Divider />
        <Calendar />
        <Divider />
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent />
          <Divider />
        </Stack>
        <Stack sx={{ p: 2 }}>
          <Button
            onClick={clearUserData}
            variant='outlined'
            fullWidth
            startIcon={<LogoutRoundedIcon />}
          >
            Wyloguj
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  )
}
